function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#c5e4fa",
  d: "M61 11v42a2 2 0 01-2 2H5a2 2 0 01-2-2V11a2 2 0 012-2h54a2 2 0 012 2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#e3f2ff",
  d: "M38.107 55L61 32.107V11.214L17.214 55zM58.7 9.94L13.64 55H5.29l46-46H57c.71 0 1.34.38 1.7.94zM47.71 9L5 51.71v-3.96L43.75 9z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff8f8",
  d: "M25.665 20.833l1.238 2.264 2.264 1.238-2.264 1.239-1.238 2.264-1.239-2.264-2.264-1.239 2.264-1.238zM50.581 21l.855 1.564 1.564.855-1.564.855-.855 1.564-.855-1.564-1.564-.855 1.564-.855zM42.81 39.542l.583 1.065 1.065.583-1.065.582-.583 1.066-.582-1.066-1.066-.582 1.066-.583z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ed7899",
  d: "M15 21h-4a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffeb9b",
  d: "M15 33h-4a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ced8ed",
  d: "M3 49h58v6H3z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M59 8H5c-1.654 0-3 1.346-3 3v42c0 1.654 1.346 3 3 3h54c1.654 0 3-1.346 3-3V11c0-1.654-1.346-3-3-3zM4 11c0-.551.448-1 1-1h54c.552 0 1 .449 1 1v37H4V11zm55 43H5c-.552 0-1-.449-1-1v-3h56v3c0 .551-.448 1-1 1z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M8 13a1 1 0 10-2 0v2a1 1 0 102 0v-2zm4 3a1 1 0 001-1v-2a1 1 0 10-2 0v2a1 1 0 001 1zm5-4a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm-42 8h-4c-1.654 0-3 1.346-3 3v4c0 1.654 1.346 3 3 3h4c1.654 0 3-1.346 3-3v-4c0-1.654-1.346-3-3-3zm1 7c0 .551-.448 1-1 1h-4c-.552 0-1-.449-1-1v-4c0-.551.448-1 1-1h4c.552 0 1 .449 1 1v4zm-1 5h-4c-1.654 0-3 1.346-3 3v4c0 1.654 1.346 3 3 3h4c1.654 0 3-1.346 3-3v-4c0-1.654-1.346-3-3-3zm1 7c0 .551-.448 1-1 1h-4c-.552 0-1-.449-1-1v-4c0-.551.448-1 1-1h4c.552 0 1 .449 1 1v4z"
});

function SvgDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default SvgDesktop;